export default "__VITE_ASSET__BXdnKukq__"